// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumCommentAdd__blockedNotice":"pl_a bia_sn bia_sv bia_sw bia_kx bia_ky bia_ke undefined bia_vt"};